module.exports = __webpack_public_path__ + "static/kelemvor-DND3_FnP-2da56da1eac6fe2899be0edd2b5f6f0c.jpg";